const PERMISSION_KEY= "core:payment_mode";
const PAGE_URL = {
    PAYMENT_MODE_PAGE: "/admin/core/payment-mode"
}

export {PERMISSION_KEY, PAGE_URL}

